

import React, { useState } from 'react';
import styles from './index.module.css';
import ProductTable from './components/ProductTable';
import ProductDetail from './components/ProductDetail';

const Products = () => {
  const [activeSection, setActiveSection] = useState('all');
  const [selectedItemCode, setSelectedItemCode] = useState(null);
  const [savedTableState, setSavedTableState] = useState({
    currentPage: 0,
    searchTerm: '',
    selectedCategory: '',
    selectedStock: 'all',
    sortBy: '',
    sortOrder: 'desc'
  });

  const handleProductClick = (itemCode, tableState) => {
    console.log('📦 Product clicked:', itemCode);
    
    // Save current table state
    setSavedTableState(tableState);
    
    // Set selected product and switch to detail view
    setSelectedItemCode(itemCode);
    setActiveSection('detail');
  };

  const handleBackToProducts = () => {
    console.log('⬅️ Going back to products list');
    setActiveSection('all');
    // selectedItemCode and savedTableState are preserved
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'all' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('all')}
          >
            All Products
          </button>
          <button
            className={`${styles.tabButton} ${activeSection === 'detail' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('detail')}
          >
            Product Detail
          </button>
        </div>

        {activeSection === 'all' && (
          <div className={styles.sectionContent}>
            <ProductTable 
              onProductClick={handleProductClick}
              savedState={savedTableState}
            />
          </div>
        )}

        {activeSection === 'detail' && (
          <div className={styles.sectionContent}>
            <ProductDetail 
              initialItemCode={selectedItemCode}
              onBack={handleBackToProducts}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Products;